import axios, { AxiosError, type AxiosInstance } from "axios";
import { toast } from "sonner";

const API_BASE = "/api/v1";

export const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  timeout: 30_000,
});

// Token interceptor
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("wow_access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor: handle 401, refresh, errors
apiClient.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Token expired — try refresh
      const refreshToken = localStorage.getItem("wow_refresh_token");
      if (refreshToken) {
        try {
          const r = await axios.post(`${API_BASE}/auth/refresh`, { refresh_token: refreshToken });
          const { access_token, refresh_token } = r.data;
          localStorage.setItem("wow_access_token", access_token);
          localStorage.setItem("wow_refresh_token", refresh_token);
          // Retry original
          if (error.config) {
            error.config.headers.Authorization = `Bearer ${access_token}`;
            return apiClient.request(error.config);
          }
        } catch {
          // Refresh failed — logout
          localStorage.removeItem("wow_access_token");
          localStorage.removeItem("wow_refresh_token");
          window.location.href = "/login";
        }
      } else {
        window.location.href = "/login";
      }
    }
    // Show toast for non-401 errors
    const data = error.response?.data as any;
    const message = data?.error?.message || error.message;
    if (error.response?.status !== 401 && error.response?.status !== 422) {
      toast.error(message);
    }
    return Promise.reject(error);
  },
);
